//document ready
$(function() {

  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();


  productPage.initializeQuantityBox();
  productPage.init();
  productPage.initAccordions();
  productPage.relatedProducts();

  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 798) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });

  
    quickShop.init();
  

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  $('form[action="/search"] input[name="query"]').each(function() {
    var $form = $(this).closest('form');
    $form.on('submit', () => {
      $(this).attr('name', 'q');
      $form.submit();
    });
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h3', 'ul');
  utils.createAccordion('.footer_content', 'h3', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  
    if ($(window).width() > 798) {
      $('body').on('mouseenter', '.collection_swatches', function() {
        $('.swatch span', $(this)).each(function() {
          var image = $(this).data("image");
          if (image.indexOf("no-image") == -1) {
            $('<img/>')[0].src = image;
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function() {
        var image = $(this).data("image") || '';
        if (image.indexOf("no-image") == -1) {
          $(this).parents('.thumbnail').find('img:not(.secondary)').attr('src', image);
          $(this).parents('.thumbnail').find('img:not(.secondary)').attr('srcset', image);
        }
      });
    }
  

  //Terms of service settings for minicart
  

  
      $('body').on('click', ".cart_content .action_button", function(e) {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = "/cart";
      });
    


  
    imageFunctions.showSecondaryImage();
  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  

  

  
    enableLoadMoreSearch();
  

  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function joinWithCommasAndAmpersand(items) {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0];

    var allButLast = items.slice(0, -1).join(', ');

    var lastItem = items[items.length - 1];

    return allButLast + ' & ' + lastItem;
  }

  function getLineItemDiscountCodes(item, cart) {
    var lineLevelDiscountApplications = (item.line_level_discount_allocations || []).map(function (allocation) {
      return allocation.discount_application;
    });

    var discountCodes = [];

    if (lineLevelDiscountApplications.length > 0) {
      lineLevelDiscountApplications.forEach(function (discountApplication) {
        if (discountApplication && discountApplication.type === 'discount_code' && discountApplication.title) {
          discountCodes.push(discountApplication.title);
        }
      });
    }

    return discountCodes;
  }

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

  // @TODO: remove after ab test
  $(document).on('ts:cart:refresh', fetchAndRefreshCart);

  $(document).on('ts:cart:updated:item_count', function (e) {
    refreshCart(e.detail.cart);
  });

  // @TODO: remove after ab test
  function fetchAndRefreshCart() {
    $.ajax({
      url: '/cart.js',
      dataType: "json",
      cache: false,
      success: function(cart) {
        refreshCart(cart);
        if($('body').hasClass('fancybox-active')) {
          $.fancybox.close();
        }

        if($('#header').is(':visible')) {
          $('#header .cart_container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart_container').addClass('active_link');
        } else {
          $('.top_bar .cart_container').addClass('active_link');
        }

        //block scrolling on mobile
        // @TODO: remove after a/b test
        if ($(window).width() <= 798 && window.tsAbTests['mini-cart'] !== 'new') {
          var $cart_container = $(this).parent();

          if ($cart_container.hasClass('active_link')) {
            $('body').addClass('blocked-scroll');
          } else {
            $('body').removeClass('blocked-scroll');
          }
        }
      }
    });
  }

  function refreshCart(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    // @TODO: remove after ab tests
    if (window.tsAbTests['mini-cart'] !== 'new') {
      var cart_items_html = "";
      var cart_action_html = "";
      var cart_savings_html = "";
      var $cart = $(".cart_content form");
      var total_savings = cart.total_discount;

      if (cart.item_count == 0) {
        $('.js-empty-cart__message').removeClass('hidden');
        $('.js-cart_content__form').addClass('hidden');
      } else {
        $('.js-empty-cart__message').addClass('hidden');
        $('.js-cart_content__form').removeClass('hidden');

        $.each(cart.items, function(index, item) {
          var line_id = index + 1;
          cart_items_html += '<li class="cart_item clearfix">' +
            '<a href="' + item.url +'">';
          if (item.image) {
            cart_items_html += '<div class="cart_image">' +
                '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
              '</div>';
          }

          cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

          var discountCodes = getLineItemDiscountCodes(item, cart);

          if (discountCodes.length > 0) {
            var discountMessagePlaceholder = "Promo \u003cb\u003e{{ discount }}\u003c\/b\u003e applied";
            var discountMessage = discountMessagePlaceholder.replace('{{ discount }}', joinWithCommasAndAmpersand(discountCodes));

            cart_items_html += '<div class="notice line-item" style="margin-top: 5px;">' + discountMessage + '</div>';
          }

          if (item.properties) {
            $.each(item.properties, function(title, value) {
              if (value && value.includes('Final')) {
                cart_items_html += '<div class="notice line-item">' + value + '</div>';
              } else if (value && title && title.charAt(0) !== '_') {
                cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
              }
            });
          }
          cart_items_html += '</div></a>';

          cart_items_html += '<div class="left product-quantity-box has-wishlist">' +
            '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
            '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
            '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
          '</div>';

          cart_items_html += `
            <div class="swym-wishlist-cart-add-button-wrapper">
              <button
                type="button"
                class="swym-wishlist-cart-add-button"
                data-variant-id="${item.variant_id}"
                data-product-id="${item.product_id}"
                data-product-name="${item.product_title}"
                data-product-url="https://toddsnyder.com/products/${item.handle}"
                data-wishlist-plp-add
              >
                <span aria-label="Add to wishlist">
                  <svg aria-hidden="true" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.857 4.179c0-.483-.064-.908-.192-1.277-.128-.37-.291-.662-.49-.88a2.358 2.358 0 0 0-.729-.53 3.222 3.222 0 0 0-.839-.278 5.106 5.106 0 0 0-.875-.071c-.31 0-.643.076-1 .228a4.564 4.564 0 0 0-.986.571c-.301.23-.559.443-.773.643-.214.2-.393.382-.536.549A.535.535 0 0 1 8 3.33a.535.535 0 0 1-.438-.196 6.912 6.912 0 0 0-.535-.55c-.215-.199-.472-.413-.773-.642-.3-.23-.629-.42-.986-.571a2.568 2.568 0 0 0-1-.228c-.31 0-.601.024-.875.071-.274.048-.554.14-.84.277a2.358 2.358 0 0 0-.727.531c-.2.218-.363.51-.491.88-.128.369-.192.794-.192 1.277 0 1 .556 2.056 1.67 3.17l5.187 5 5.179-4.992c1.119-1.119 1.678-2.178 1.678-3.178Zm1.143 0c0 1.315-.681 2.654-2.045 4.017l-5.562 5.358a.535.535 0 0 1-.393.16.535.535 0 0 1-.393-.16L2.036 8.179a2.949 2.949 0 0 1-.246-.233 9.18 9.18 0 0 1-.495-.584 7.901 7.901 0 0 1-.607-.87A5.407 5.407 0 0 1 .21 5.41 3.911 3.911 0 0 1 0 4.179c0-1.31.378-2.334 1.134-3.072C1.89.37 2.934 0 4.268 0c.369 0 .745.064 1.13.192.383.128.74.3 1.07.518.331.217.615.42.853.611.239.19.465.393.679.608.214-.215.44-.417.679-.608.238-.19.522-.394.852-.611a4.57 4.57 0 0 1 1.072-.518c.384-.128.76-.192 1.13-.192 1.332 0 2.377.369 3.133 1.107C15.622 1.845 16 2.87 16 4.18Z" fill="currentColor"/></svg>
                </span>

                <span aria-label="Remove from wishlist">
                  <svg aria-hidden="true" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 4.179c0 1.315-.681 2.654-2.045 4.017l-5.562 5.358a.535.535 0 0 1-.393.16.535.535 0 0 1-.393-.16L2.036 8.179a2.949 2.949 0 0 1-.246-.233 9.18 9.18 0 0 1-.495-.584 7.901 7.901 0 0 1-.607-.87A5.407 5.407 0 0 1 .21 5.41 3.911 3.911 0 0 1 0 4.179c0-1.31.378-2.334 1.134-3.072C1.89.37 2.934 0 4.268 0c.369 0 .745.064 1.13.192.383.128.74.3 1.07.518.331.217.615.42.853.611.239.19.465.393.679.608.214-.215.44-.417.679-.608.238-.19.522-.394.852-.611a4.57 4.57 0 0 1 1.072-.518c.384-.128.76-.192 1.13-.192 1.332 0 2.377.369 3.133 1.107C15.622 1.845 16 2.87 16 4.18Z" fill="currentColor"/>
                    <path d="M14.857 4.179c0-.483-.064-.908-.192-1.277-.128-.37-.291-.662-.49-.88a2.358 2.358 0 0 0-.729-.53 3.222 3.222 0 0 0-.839-.278 5.106 5.106 0 0 0-.875-.071c-.31 0-.643.076-1 .228a4.564 4.564 0 0 0-.986.571c-.301.23-.559.443-.773.643-.214.2-.393.382-.536.549A.535.535 0 0 1 8 3.33a.535.535 0 0 1-.438-.196 6.912 6.912 0 0 0-.535-.55c-.215-.199-.472-.413-.773-.642-.3-.23-.629-.42-.986-.571a2.568 2.568 0 0 0-1-.228c-.31 0-.601.024-.875.071-.274.048-.554.14-.84.277a2.358 2.358 0 0 0-.727.531c-.2.218-.363.51-.491.88-.128.369-.192.794-.192 1.277 0 1 .556 2.056 1.67 3.17l5.187 5 5.179-4.992c1.119-1.119 1.678-2.178 1.678-3.178Zm1.143 0c0 1.315-.681 2.654-2.045 4.017l-5.562 5.358a.535.535 0 0 1-.393.16.535.535 0 0 1-.393-.16L2.036 8.179a2.949 2.949 0 0 1-.246-.233 9.18 9.18 0 0 1-.495-.584 7.901 7.901 0 0 1-.607-.87A5.407 5.407 0 0 1 .21 5.41 3.911 3.911 0 0 1 0 4.179c0-1.31.378-2.334 1.134-3.072C1.89.37 2.934 0 4.268 0c.369 0 .745.064 1.13.192.383.128.74.3 1.07.518.331.217.615.42.853.611.239.19.465.393.679.608.214-.215.44-.417.679-.608.238-.19.522-.394.852-.611a4.57 4.57 0 0 1 1.072-.518c.384-.128.76-.192 1.13-.192 1.332 0 2.377.369 3.133 1.107C15.622 1.845 16 2.87 16 4.18Z" fill="#fff"/>
                  </svg>
                </span>

              </button>
            </div>
          `;

          cart_items_html += '</div>';

          cart_items_html += '<strong class="right price">';

          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            url: "/products/" + item.handle + ".js",
            success: function(data) {
              var variant_id = item.variant_id;
              var variant = $.grep(data.variants, function(v) {
                return v.id == variant_id;
              });

              if(variant[0] && variant[0].compare_at_price > item.final_price) {
                cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                total_savings += (variant[0].compare_at_price - item.final_price) * item.quantity;
              }
            }
          });

          cart_items_html += '<span class="money">' + Shopify.formatMoney(item.final_price, $('body').data('money-format')) + '</span></strong>' + '</div>';
        });

        cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' +
            '<span>Subtotal</span>';

        if(total_savings > 0 ) {
          var discountCodes = cart.cart_level_discount_applications.map(discount => discount.discount_application ? discount.discount_application.title : discount.title);
          var totalSavingsLabel = discountCodes.length > 0 ? "Discounts applied \u003cbr\/\u003e (inc. \u003cb\u003e{{ discount }}\u003c\/b\u003e)".replace('{{ discount }}', joinWithCommasAndAmpersand(discountCodes)) : "Discounts applied";

          cart_savings_html = `
            <span class="right">
              <span class="money">
                -${Shopify.formatMoney(total_savings, $('body').data('money-format'))}
              </span>
            </span>

            <span class="cart_savings-label">
              <svg viewBox="0 0 512 512" width="20" height="20">
                <path fill="currentColor" d="m345 39.1 127.8 129.3c52.4 53 52.4 138.2 0 191.2l-112 113.3c-9.3 9.4-24.5 9.5-33.9.2s-9.5-24.5-.2-33.9l111.9-113.3c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6.2-33.9s24.6-9.2 33.9.2zM0 229.5V80c0-26.5 21.5-48 48-48h149.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z" />
              </svg>

              <span>${totalSavingsLabel}</span>
            </span>
          `;
        } else {
          cart_savings_html = '';
        }
      }

      $('.js-cart_items').html(cart_items_html);
      $('.js-cart_subtotal').html(cart_action_html);
      $('.js-cart_savings').html(cart_savings_html);

      if (theme.TSWishlistPlpButton !== undefined) {
        var wishlistButtons = $('.js-cart_items button[data-wishlist-plp-add]').toArray();
        wishlistButtons.forEach(function (button) {
          const wishlistPlpButton = new theme.TSWishlistPlpButton(button);
          wishlistPlpButton.init();
        });
      }
    }

    
  }

  $('body').on("change", "#cart_form input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

  
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();

      var $addToCartForm = $(this).closest('form');
      var isSuit = $addToCartForm.attr('data-suit-product') === 'true';
      var isSizeSelected = true;

      var productFormStyle = window.abProductFormStyle || $addToCartForm.data('product-form-style');
      var $addToCartBtn = $(this);

      var formData = $addToCartForm.serialize();

      var size_notice_message = "Please select a size.";

      if (isSuit === true) {
        var $suitComponentSelect = $(this).siblings('select[data-suit-component-type]');
        var isSizeSelected = true;

        if ($suitComponentSelect.length > 0 && Boolean($suitComponentSelect.val()) === false) {
          isSizeSelected = false;

          size_notice_message = "Please select a {{ component }} size.".replace('{{ component }}', $suitComponentSelect.data('suit-component-type'));
        }

        formData = `id=${$suitComponentSelect.val()}&quantity=1`;
      } else {
        var $selectedSizeOptionInput = $addToCartForm.find('input[type="radio"][name="option-0"]');
        var $selectedSizeCheckedOptionInput = $addToCartForm.find('input[type="radio"][name="option-0"]:checked');
        isSizeSelected = $selectedSizeOptionInput.length === 0 || $selectedSizeCheckedOptionInput.length > 0;

        if (productFormStyle === 'dropdown') {
          var $selectedSizeSelectInput = $addToCartForm.find('select[data-option="option1"]');
          isSizeSelected = $selectedSizeSelectInput.length === 0 || Boolean($selectedSizeSelectInput.val());
        }

        if ($addToCartBtn.data('bis-variant')) {
          document.dispatchEvent(new CustomEvent('ts:swym:bis:add', {
            detail: $addToCartBtn.data('bis-variant')
          }));

          return;
        }
      }

      if (!$(e.currentTarget).hasClass('ajax-submit-simple')) {
        if (isSizeSelected === false) {
          $addToCartForm.find('.size-notice').remove();

          var warning = '<p class="notice notice--caps notice--bold size-notice animated fadeIn">' + size_notice_message + '</p>';
          $addToCartForm.find('.purchase-details').before(warning);

          return;
        } else {
          $addToCartForm.find('.size-notice').remove();
        }
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: formData,
        beforeSend: function() {
          $('.warning').remove();
          $('.notice').remove();
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          document.dispatchEvent(new CustomEvent('ts:cart:refresh'));
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.message;
          $('.notice').remove();

          var warning = '<p class="notice notice--caps notice--bold animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.find('.purchase-details__buttons').before(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  

  productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof Shopify) var Shopify = {};
(Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}),
(Shopify.map = function (t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o;
}),
(Shopify.arrayIncludes = function (t, e) {
    for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1;
}),
(Shopify.uniq = function (t) {
    for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e;
}),
(Shopify.isDefined = function (t) {
    return "undefined" == typeof t ? !1 : !0;
}),
(Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1);
}),
(Shopify.extend = function (t, e) {
    function o() {}
    (o.prototype = e.prototype), (t.prototype = new o()), (t.prototype.constructor = t), (t.baseConstructor = e), (t.superClass = e.prototype);
}),
(Shopify.locationSearch = function () {
    return window.location.search;
}),
(Shopify.locationHash = function () {
    return window.location.hash;
}),
(Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t);
}),
(Shopify.urlParam = function (t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "));
}),
(Shopify.newState = function (t, e) {
    var o;
    return (
        (o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e),
        o + Shopify.locationHash()
    );
}),
(Shopify.setParam = function (t, e) {
    Shopify.replaceState(Shopify.newState(t, e));
});

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.productSwatches();
      productPage.relatedProducts();
      recentlyViewed.init();
      
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});
